import { finish, error } from '../../../modules/sports/actions/get';
import api from '../../../api';

export function request(dispatch, { data }) {
    $appState.sdkStaff.getAllSports()
        .then((sports) => dispatch(finish(sports)))
        .catch(({ errors }) => dispatch(error(errors)));

    // left for debug
    // api.get('/sports', void 0, {
    //     cache: 1000,
    //     headers: {
    //         'Cache-Control': data && data.cache ? 'public,max-age=3600' : 'no-cache, must-revalidate'
    //     }
    //
    // }).then(
    //     (sports) => {
    //         // dispatch(finish(sports))
    //         console.log('sports', sports);
    //     });
}
